/* eslint-disable no-restricted-syntax */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer, Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { TaskService } from 'components/organisms/document/services/task';

export const TaskIdAttibute = 'taskid';
export const TaskTypeAttibute = 'tasktype';
export const TaskActiveAttibute = 'taskactive';

interface CommandOptions {
  taskId: string;
  taskType: string;
}

export class InsertTaskCommand extends Command {
  editor: Editor;

  valueId: string;

  isEnabled: boolean;

  constructor(editor: Editor) {
    super(editor);
    this.editor = editor;
    this.valueId = '';
    this.isEnabled = false;
  }

  async execute(options: CommandOptions): Promise<void> {
    const { taskId, taskType } = options;
    const { model } = this.editor;
    const { document } = model;
    const { selection } = document;

    model.change((writer: Writer) => {
      const ranges = model.schema.getValidRanges(
        selection.getRanges(),
        TaskIdAttibute,
      );

      for (const range of ranges) {
        if (taskId) {
          writer.setAttribute(TaskIdAttibute, taskId, range);
          writer.setAttribute(TaskTypeAttibute, taskType, range);
        } else {
          writer.removeAttribute(TaskIdAttibute, range);
        }
      }
    });
  }

  refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;

    this.valueId = selection.getAttribute(TaskIdAttibute);
    if (this.valueId) {
      TaskService.sendData(this.valueId);
    }
    const isPossibleToAdd = model.schema.checkAttributeInSelection(
      selection,
      TaskIdAttibute,
    );

    this.isEnabled = isPossibleToAdd;
  }
}
